module.exports = __webpack_public_path__ + "e4581a2252d4f95f031a9c8299a09222.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/search.svg
// module id = 473
// module chunks = 0